import React, { useContext, useCallback } from 'react';
import { PureTranslator, Translator } from 'ggApp/modules/translator';
import { OrderContext } from 'ggApp/shared/context/Order/OrderContext';

import ExclamationMarkInCircle from 'ggApp/shared/icons/ExclamationMarkInCircle';
import { ErrorScreen, ErrorIcon, ErrorTitle, ErrorContent, ErrorCta } from './styles';

interface ErrorProps {
    stepData: {
        heading: string;
        content: string;
        ctaContent: string;
    };
    onCTAclick?: () => void;
}

export const OrderError = ({ stepData, onCTAclick }: ErrorProps): JSX.Element => {
    const { send } = useContext(OrderContext);

    const handleBackButton = useCallback(() => {
        if (onCTAclick && typeof onCTAclick === 'function') {
            onCTAclick();
        } else {
            send('BACK');
        }
    }, [send, onCTAclick]);

    return (
        <ErrorScreen>
            <ErrorIcon>
                <ExclamationMarkInCircle color="#ef432d" size="28" />
            </ErrorIcon>

            <ErrorTitle>
                <PureTranslator tk={stepData.heading} />
            </ErrorTitle>

            <ErrorContent>
                <Translator tk={stepData.content} />
            </ErrorContent>

            <ErrorCta fullWidth onClick={handleBackButton}>
                <PureTranslator tk={stepData.ctaContent} />
            </ErrorCta>
        </ErrorScreen>
    );
};
